import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bdo-square-icon-text',
    templateUrl: './square-icon-text.component.html',
    styleUrls: ['./square-icon-text.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SquareIconTextComponent {
  @Input() routerUrl: string;
  @Input() text: string;
  @Input() dataQa: string;
}
